import * as types from '../constants/ActionTypes';
import { contactPage, suggestTopics } from '../constants/UtilVariables';
import { fetchPhoneNumber } from './action-call-us';
import getTopicTree from '../../home/actions/action-topic-list';
import { fetchTopicTree } from '../actions/action-message-topic-tree';
import { fetchRelatedTopic } from './action-quick-answer-topics';
import { isLoggedIn } from '../../lib/page';
import { fetchPPCEnable } from './action-ppc-checker';

function redirecLocation({ pageName }) {
  return {
    type: types.CONTACT_LOCATION_CHANGE,
    payload: { pageName },
  };
}

// Check Current location and send API request for different locations
function locationChecker() {
  return (dispatch, getState) => {
    const state = getState();
    const { location: { pageName } } = state;

    switch (pageName) {
      case contactPage.callUs:
        dispatch(fetchPhoneNumber());
        dispatch(getTopicTree());
        dispatch(fetchRelatedTopic(suggestTopics.callUs));
        if (isLoggedIn()) {
          dispatch(fetchPPCEnable());
        }
        break;

      case contactPage.email:
        dispatch(fetchTopicTree());
        dispatch(getTopicTree());
        dispatch(fetchRelatedTopic(suggestTopics.email));
        break;

      default:
        break;
    }
    return {
      type: types.CONTACT_LOCATION_LOAD,
    };
  };
}

// Update current location action, if users go to Email/CallUs page/Channel Steering
function locationUpdate({ pageName }) {
  return (dispatch) => {
    if (pageName) {
      dispatch(redirecLocation({ pageName }));
      dispatch(locationChecker());
    }
  };
}

export default {
  locationUpdate,
  locationChecker,
};
